import { render, staticRenderFns } from "./BuildingField.vue?vue&type=template&id=a02f8cfa"
import script from "./BuildingField.vue?vue&type=script&lang=js"
export * from "./BuildingField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports